export enum CarePlanType {
  Undefined = "UNDEFINED",
  Template = 'TEMPLATE',
  Workspace = 'WORKSPACE'
}

export enum CarePlanStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Retired = 'RETIRED'
}

export enum WidgetStatus {
  Await = "AWAIT",
  Ok = "OK"
}

export enum BuilderParts {
  Settings = "SETTINGS",
  Build = "BUILD",
  Publish = "PUBLISH"
}

export enum OrderByDate {
  Newest = "NEWEST",
  Oldest = "OLDEST"
}